module.exports = __webpack_public_path__ + "static/media/home.3d0c1bb3.webp";